import React from 'react';
import PropTypes from 'prop-types';
import { SECONDARY_COLOR } from '../colors';
import Styles from './index.css';

/**
 * DEPREACTED
 * Status panel
 * this component shows in serie several status (buttons/status panel)
 * Parameters (Props):
 * @param array statusDisplay [{status: <Status={} disable={} styles={} stylesBox={} onClick={} />}]
 * @param object styles: style from the component around the status
 *
 * note: if you add in the styles the backgroundColor, you also we need to change it
 * in the statusDisplay.styles and statusDisplay.stylesBox
 */
export default class StatusPanel extends React.PureComponent {
  render() {
    const { statusDisplay, styles } = this.props;
    if (!statusDisplay || statusDisplay.length === 0) {
      return <div />;
    }
    const styleBackground = { backgroundColor: SECONDARY_COLOR };

    return (
      <div style={{ ...styleBackground, ...Styles.statusPanel, ...styles }}>
        {statusDisplay.map((status, index) => (
          <div key={index.toString()}>{status.status}</div>
        ))}
      </div>
    );
  }
}

StatusPanel.propTypes = {
  statusDisplay: PropTypes.arrayOf(PropTypes.objects).isRequired,
  styles: PropTypes.objectOf(PropTypes),
};

StatusPanel.defaultProps = {
  styles: {},
};
